const getReactPlayerConfig = ({ vimeoPlayerOptions = {} } = {}) => ({
  vimeo: {
    playerOptions: {
      playsinline: 1,
      ...vimeoPlayerOptions,
    },
  },
});

export default getReactPlayerConfig;
